import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { PortalPolicies } from "@/components/portal/portal-policies";
import { portalPoliciesQuery, requirePortalFeature } from "@/lib/portal-data";

export const Route = createFileRoute("/portal/policies")({
  beforeLoad: ({ context }) => requirePortalFeature(context.queryClient, "policies"),
  loader: ({ context }) => context.queryClient.ensureQueryData(portalPoliciesQuery),
  component: PortalPoliciesPage,
});

function PortalPoliciesPage() {
  const { data } = useQuery(portalPoliciesQuery);
  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="font-heading font-semibold text-2xl tracking-tight">Policies</h1>
        <p className="text-muted-foreground text-sm">
          Company policies for you to read and acknowledge.
        </p>
      </div>
      <PortalPolicies policies={data ?? []} />
    </div>
  );
}
